// expandable items
$('.expandable-items .item .item__toggle').on( 'click', function(e) {
    e.preventDefault();

    let $toggle = $(this),
        $item = $toggle.closest('.item'),
        toggledClass = 'item--toggled',
        $content = $toggle.siblings('.item__content');

    if ( $item.hasClass(toggledClass) ) {
        $item.removeClass(toggledClass);
        $content.stop().slideUp( 150, 'easeInOutCubic' );
    } else {
        $item.addClass(toggledClass);
        $content.stop().slideDown( {
            duration: 150,
            easing: 'easeInOutCubic',
            start: function() {
                $(this).css('display', 'flex');
            }
        });
    }
});

// expand pre-toggled expandable items on pageload
$('.expandable-items .item.item--toggled').each( function() {
    let $content = $(this).find('.item__content');

    $content.css('display', 'flex');
});